<div class="container-fluid" style="margin-top: 5% !important;" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'">
  <div class="card mt-1">
    <span class="text-center" style="color: #de2460">
      <i class="bi bi-circle-fill mr-3 " style="font-size: 8px"></i>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteConCodigoBantrab === 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente deben ser registrados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor deben ser registrados
        </span>
      </span>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'
        && clientData.cliente.existeClienteConCodigoBantrab !== 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente se encuentran desactualizados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor se encuentran desactualizados
        </span>
      </span>
    </span>
  </div>
</div>
<div class="container-fluid">
    <div class="row header-consolidacion">
        <div class="col-md-9">
            <div class="row">
                <div class="col-2">
                    <ngx-avatar size="40" src="assets/images/general/avatar.png"></ngx-avatar>
                </div>
                <div class="col-10">
                    <h4>{{clientData.cliente.nombreCompleto|accentMark: false }}</h4>
                    <p>Código Cliente: {{clientData.cliente.codigoClienteBantrab}}</p>
                </div>
            </div>
        </div>
        <div class="col-md-3">

        </div>
    </div>
    <div class="title">
        <h2>Productos Internos</h2>
        <h3 *ngIf="tieneTarjeta == 'N' && tieneCreditos=='N'">*El cliente actualmente no posee productos internos*</h3>
    </div>
    <div *ngFor="let item of productosCliente; let i = index">
        <div class="producto" *ngIf="item.nomEntidad == 'BANCO DE LOS TRABAJADORES'" (click)="selectProducto(item)">
            <div class="row m-0">
                <div class="col-md-2 p-1">
                    <img *ngIf="item.descTipoActivo == 'Prestamos' || item.descTipoActivo == 'Factoraje'"
                        src="../../../assets/icons/credito.png" height="45px">
                    <img *ngIf="item.descTipoActivo == 'Tarjeta de Credito'"
                        src="../../../assets/icons/tarjetadebito.png" height="40px">
                </div>
                <div class="col-md-10 p-0">
                    <h1><strong>{{item.descTipoActivo.toUpperCase()}}</strong></h1>
                    <h1>{{item.CodEntidad}}</h1>
                    <h2>{{item.DIRECTO_INDIRECTO}}</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="title" *ngIf="!clienteserviceParam.consultaFlag">
        <h2>Productos Externos</h2>
        <h3 *ngIf='tieneProductosE == "N"' class="mb-4">*El cliente actualmente no posee productos externos*</h3>
    </div>
    <div *ngIf="!clienteserviceParam.consultaFlag">
        <div *ngFor="let item of productosCliente; let i = index">
            <div class="producto" *ngIf="item.nomEntidad !== 'BANCO DE LOS TRABAJADORES'" (click)="selectProducto(item)">
                <div class="row m-0">
                    <div class="col-md-2 p-1">
                        <img *ngIf="item.descTipoActivo == 'Prestamos' || item.descTipoActivo == 'Factoraje'"
                            src="../../../assets/icons/credito.png" height="45px">
                        <img *ngIf="item.descTipoActivo == 'Tarjeta de Credito'"
                            src="../../../assets/icons/tarjetadebito.png" height="40px">
                    </div>
                    <div class="col-md-4 p-0">
                        <h1><strong>{{item.descTipoActivo.toUpperCase()}}</strong></h1>
                        <h1>{{item.CodEntidad}}</h1>
                        <h2>{{item.DIRECTO_INDIRECTO}}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="title" *ngIf="clienteserviceParam.consultaFlag">
        <h2>Cuentas Existentes</h2>
        <h3 *ngIf='cuentasCliente.length==0' class="mb-4">*El cliente actualmente no posee cuentas*</h3>
    </div>
    <div *ngIf="cuentasCliente.length>0">
        <div *ngFor="let item of cuentasCliente; let i = index">
            <div class="producto" *ngIf="item.tipoCuenta==1 || item.tipoCuenta==2" style="height:180px;">
                <div class="row m-0">
                    <div class="col-md-2 p-1">
                        <img src="../../../assets/icons/credito.png" height="45px">
                    </div>
                    <div class="col-md-10 p-0">
                        <div class="row m-0">
                            <div class="col-md-12 p-0">
                                <h1 style="text-align: center;"><strong>Producto</strong></h1>
                                <h1 style="text-align: center;">{{item.producto.toUpperCase()}}</h1>
                            </div>
                            <div class="col-md-6 p-0">
                                <h3>No. cuenta</h3>
                            </div>
                            <div class="col-md-6 p-0">
                                <h4>{{item.cuenta}}</h4>
                            </div>
                            <div class="col-md-6 p-0">
                                <h3><strong>Fomento de ahorro</strong></h3>
                            </div>
                            <div class="col-md-6 p-0">
                                <h4>{{item.ahorroConstante}}</h4>
                            </div>
                            <div class="col-md-6 p-0">
                                <h3><strong>Estatus</strong></h3>
                            </div>
                            <div class="col-md-6 p-0">
                                <h4>{{item.estatus}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div style="text-align: left;">
                <button class="btn round-button-back" (click)="goBack()">Regresar</button>
            </div>
        </div>
        <div class="col-md-6" *ngIf="clienteserviceParam.flowType === 'DEBTOR' && !clienteserviceParam.consultaFlag && clienteserviceParam.tipoPrecalificacion == 'credito_fiduciario'">
            <div style="text-align: right;">
                <button class="btn round-button" (click)="consolidarDeudas()">Continuar</button>
            </div>
        </div>
        <div class="col-md-6" *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          <div style="text-align: right;">
            <button class="btn round-button" (click)="validateCoDebtor()">Continuar</button>
          </div>
        </div>
        <div class="col-md-6" *ngIf="clienteserviceParam.flowType === 'DEBTOR' && !clienteserviceParam.consultaFlag && clienteserviceParam.tipoPrecalificacion == 'tarjeta_credito'">
            <div style="text-align: right;">
                <button class="btn round-button" (click)="solicitudOfertaTc()">Continuar</button>
            </div>
        </div>
    </div>
</div>
